import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const API_BASE = "https://api.topgunapp.com";

export default function BlogPostPage() {
  const { id } = useParams(); // route: /blog/:id
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/api/v1/aircrafts/blog/${id}`)
      .then((res) => {
        if (!res.ok) throw new Error("Post not found");
        return res.json();
      })
      .then((data) => {
        setPost(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <section className="section container" style={{ paddingTop: "8rem" }}>
        <p>Loading...</p>
      </section>
    );
  }

  if (error || !post) {
    return (
      <section className="section container" style={{ paddingTop: "8rem" }}>
        <h1 className="section__title section__title-gradient">
          Post not found
        </h1>
        <p>The post you requested does not exist.</p>
        <Link to="/blog" className="button button--flex">
          Back to Blog <i className="ri-arrow-left-line" />
        </Link>
      </section>
    );
  }

  return (
    <section className="section container" style={{ paddingTop: "8rem" }}>
      <Helmet>
        <title>{post.title} | TopGun Blog</title>
        <meta name="description" content={post.sub_header} />
      </Helmet>

      {/* Title */}
      <h1 className="section__title section__title-gradient">
        {post.title}
      </h1>

      {/* Meta */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: ".75rem",
          marginBottom: "1.5rem",
          color: "var(--text-color-light)",
        }}
      >
        {post.source_logo && (
          <img
            src={`${API_BASE}${post.source_logo}`}
            alt={post.source}
            style={{ width: 28, height: 28, borderRadius: "50%" }}
          />
        )}
        <span>
          {post.source} •{" "}
          {new Date(post.created).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </span>
      </div>

      {/* Image */}
      {post.image && (
        <img
          src={`${API_BASE}${post.image}`}
          alt={post.title}
          style={{
            width: "100%",
            maxHeight: "420px",
            objectFit: "cover",
            borderRadius: "1rem",
            marginBottom: "2rem",
          }}
        />
      )}

      {/* Sub header */}
      {post.sub_header && (
        <h3
          style={{
            marginBottom: "1.5rem",
            color: "var(--text-color-light)",
            fontWeight: 400,
          }}
        >
          {post.sub_header}
        </h3>
      )}

      {/* Description */}
      <div
        style={{
          lineHeight: "2rem",
          whiteSpace: "pre-line",
        }}
      >
        {post.description}
      </div>

      {/* Back */}
      <div style={{ marginTop: "2.5rem" }}>
        <Link to="/blog" className="button button--flex">
          Back to Blog <i className="ri-arrow-left-line" />
        </Link>
      </div>
    </section>
  );
}
